import {IMuWidget} from "./IMuWidget";

export class TicketTree extends IMuWidget
{
	public treeData : any[];

	public ticketId;

	private tree: any;

	public afterIndex()
	{
		this.tree = $(this.ui.tree).fancytree({
			source: this.treeData,// this.items,
			extensions: ["table"],
			renderColumns: (event, data) => {
				const rw = this.muActivateWidget(data.node.tr);
				rw.muBindData(data.node.data);
				if (this.ticketId == data.node.key) rw.ui.summary.classList.add("strong");
				rw.muVisible(!data.node.data.disabled, 'summary');
				rw.muVisible(data.node.data.disabled, 'summaryDisabled');
			},
			activate: (event, data) => { }
		}).fancytree("getTree");
	}

	expandTo(el)
	{
		this.expandNode(this.tree.rootNode, el.attributes['data-level'].value);
	}

	expandNode(node, level)
	{
		node.setExpanded(level > 0);
		if (level > 0 && node.children)
		{
			for (var i = 0; i < node.children.length; i++)
			{
				this.expandNode(node.children[i], level - 1);
			}
		}
	}
}

